<div
  class="flex min-w-16 max-w-24 items-center gap-px overflow-hidden rounded-full bg-slate-300"
>
  @for (step of steps; track step) {
    <div
      class="h-2"
      [class]="getColor(step.color)"
      [style.flex-grow]="step.progress"
    ></div>
  }

  @if (currentProgress < total) {
    <div
      class="h-[6px] bg-slate-300"
      [style.flex-grow]="total - currentProgress"
    ></div>
  }
</div>
